import { InjectionToken, Provider } from '@angular/core';
import { VehicleRepository } from '../../domain/vehicle.repository';
import { VehiclesApiService } from '../vehicles-api.service';

export const VEHICLES_REPOSITORY = new InjectionToken<VehicleRepository>('VehicleRepository');

export const VEHICLES_API_PROVIDER: Provider = {
    provide: VehicleRepository,
    useClass: VehiclesApiService,
};
